import React, { useEffect, useState } from "react";
import Header from "../Components/Header";
import PageHeader from "../Components/PageHeader";
import UserProfileSidebar from "../Components/UserProfileSidebar";
import Footer from "../Components/Footer";
import { Link } from "react-router-dom";
import { doctorimg } from "../Constant/Index";
import { getPatientappointmentsapi } from "../network/Network";
import { useSelector } from "react-redux";
import Pagination from "../Components/Pagination";
import Norecord from "../Components/Norecord";

const UserMyConsultations = () => {
	const token = useSelector((state) => state?.Auth?.token);
	const [clickedButton, setClickedButton] = useState("upcoming");
	const [appointments, setAppointments] = useState({
		upcoming: [],
		current: [],
		past: [],
	});
	const [current_page, setCurrent_page] = useState(1);
	const [pageCount, setPageCount] = useState();

	// Button Handler
	const handleClick = (buttonName) => {
		setClickedButton(buttonName);
		setCurrent_page(1);
	};

	// Get Appointment Api
	useEffect(() => {
		getPatientappointmentsapi(clickedButton, token, current_page).then(
			(res) => {
				const newAppointments = { ...appointments };
				newAppointments[clickedButton] = res?.data?.data || [];
				setAppointments(newAppointments);

				const total = res?.data?.total || 0;
				const limit = res?.data?.per_page || 1;
				setPageCount(Math.ceil(total / limit));
			},
		);
	}, [clickedButton, current_page]);
	// ======================

	return (
		<>
			<Header />
			<PageHeader pagename="User Profile" />
			<section className="main-sidebar user-profile">
				<div className="container">
					<div className="row">
						<div className="col-lg-4">
							<UserProfileSidebar />
						</div>
						<div className="col-lg-8">
							<div className="main-profile-content radius-20 p-4 patient-appointment_dv">
								<div className="main-headind wrapper-d-fff d-flex align-items-center 	 mb-3  justify-content-between w-100">
									<div className="d-flex gap-2 align-items-center">
										<div className="edit-btn back">
											<div className="nav-anchor">
												<i className="fa-solid fa-arrow-left"></i>
											</div>
										</div>
										<div>
											<h5 className="main-heading level-6 ps-2 main-heading-font dark-color mb-0 wow animate__animated            animate__zoomIn animate__delay-1s ">
												My Consultations
											</h5>
										</div>
									</div>
									<div className="">
										<div className="btn_consultation">
											<button
												className={
													clickedButton == "upcoming" ? "active_btn" : ""
												}
												onClick={() => handleClick("upcoming")}
											>
												upcoming
											</button>
											<button
												className={
													clickedButton == "current" ? "active_btn" : ""
												}
												onClick={() => handleClick("current")}
											>
												current
											</button>
											<button
												className={clickedButton == "past" ? "active_btn" : ""}
												onClick={() => handleClick("past")}
											>
												past
											</button>
										</div>
									</div>
								</div>
								<div className="row">
									{appointments[clickedButton]?.length > 0 ? (
										appointments[clickedButton].map((data, index) => (
											<div className="col-lg-6 col-md-6 mt-4" key={index}>
												{console.log(data, "asdmasdmas2")}
												<div
													className={
														clickedButton === "current"
															? "dark-bg doctor-detail-des main-profile-content radius-35 padding-profile"
															: "doctor-detail-des main-profile-content radius-20 p-4"
													}
												>
													<div className="d-flex align-items-center gap-3 mb-2">
														<img
															src={data?.physician_profile_image_url}
															className="img-fluid profie_img"
															alt=""
														/>
														<div>
															<h4
																className={
																	clickedButton === "current"
																		? "main-heading-font text-white mb-0"
																		: "main-heading-font dark-color mb-0"
																}
															>
																{data?.physician_title}
															</h4>
															<h5 className="mb-0 extra-color-9">
																{data?.physician_degree_title}
															</h5>
														</div>
													</div>
													<div className="mt-4 date_time_class">
														<Link
															className={
																clickedButton === "current"
																	? "detail-physician-btn d-flex align-items-center justify-content-center w-100 text-white extra-bg-16"
																	: "detail-physician-btn"
															}
															to={`/consultation-detail/${data?.booking_id}`}
														>
															{data?.booking_day} {data?.booking_date}{" "}
															{/* {new Date(data?.booking_date).toLocaleDateString(
																"en-GB",
																{
																	day: "2-digit",
																	month: "long",
																	year: "numeric",
																},
															)}{" "} */}
															({data?.booking_time})
														</Link>
													</div>
												</div>
											</div>
										))
									) : (
										<Norecord />
									)}
								</div>
								<Pagination
									pageCount={pageCount}
									setPageCount={setPageCount}
									current_page={current_page}
									setCurrent_page={setCurrent_page}
									apicall={appointments}
								/>
							</div>
						</div>
					</div>
				</div>
			</section>
			<Footer />
		</>
	);
};

export default UserMyConsultations;
